import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as common from '../../../../../../../../common'
import * as enums from '../../../../../enums'
import * as category from '../category'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: category.RESOURCE.payload.dimension.partialId,
      partialId: category.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: common.FaFunction.Type.Direct,
    description: 'What types of costs does this category correspond to?',
    isOptional: false,
    name: 'Type',
    partialId: PartialId.Standard.create('type'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.idcFunctionType.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
